<template>
  <default-layout>
    <div class="flex justify-between pb-5">
      <div class="text-2xl font-bold">Admin Portal</div>
    </div>
    <div
      class="max-w-screen-3xl bg-white text-sm cursor-default rounded border border-coolGray-200 p-5"
    >
      <div class="flex border-b border-coolGray-200 h-7 mb-7">
        <button
          :class="
            tab === 'admin-analytics'
              ? ['text-primary border-solid	border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-analytics')"
        >
          {{ `Analytics` }}
        </button>
        <button
          :class="
            tab === 'admin-users' || tab === 'admin-add-users'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-users')"
        >
          {{ `Users` }}
        </button>
        <button
          :class="
            tab === 'admin-courses' || tab === 'admin-add-courses'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-courses')"
        >
          {{ `Courses` }}
        </button>
        <button
          :class="
            tab === 'admin-integrations'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-integrations')"
        >
          {{ `Integrations` }}
        </button>
        <div class="flex">
          <button
            :class="
              tab === 'admin-suggestions'
                ? ['text-primary border-solid border-b-2 border-primary']
                : []
            "
            class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
            @click="goToTab('admin-suggestions')"
          >
            {{ `Suggestions` }}
          </button>
          <div
            v-if="has_new_suggestions"
            class="bg-pinky w-2 h-2 mt-1 -ml-7 mr-7 text-center rounded-full text-white"
          ></div>
        </div>
        <button
          v-if="getProfile.role === 'admin'"
          :class="
            tab === 'admin-school-info'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-school-info')"
        >
          {{ `School Info` }}
        </button>
        <button
          v-if="getProfile.role === 'admin'"
          :class="
            tab === 'admin-memberships'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-memberships')"
        >
          {{ `Memberships` }}
        </button>
        <!-- <button
          :class="
            tab === 'admin-book'
              ? ['text-primary border-solid border-b-2 border-primary']
              : []
          "
          class="text-sm text-gray-400 font-semibold cursor-pointer mr-7 border-0"
          @click="goToTab('admin-book')"
        >
          {{ `Book PD` }}
        </button> -->
      </div>
      <admin-portal-analytics v-if="tab === 'admin-analytics'" />
      <admin-portal-users
        v-if="tab === 'admin-users' || $route.name === 'admin-users'"
      />
      <admin-portal-courses
        v-if="tab === 'admin-courses' || $route.name === 'admin-courses'"
      />
      <admin-portal-integrations v-if="tab === 'admin-integrations'" />
      <suggestions-tab v-if="tab === 'admin-suggestions'" />
      <admin-portal-school-info
        v-if="tab === 'admin-school-info' && getProfile.role === 'admin'"
      />
      <admin-memberships
        v-if="tab === 'admin-memberships' && getProfile.role === 'admin'"
      />
      <admin-portal-add-users
        v-if="
          tab === 'admin-add-users' &&
          (getProfile.role === 'admin' || hasAdminPermission) &&
          addUsers
        "
      />
      <admin-portal-add-courses
        v-if="
          tab === 'admin-add-courses' &&
          (getProfile.role === 'admin' || hasAdminPermission) &&
          addCourses
        "
      />
      <!-- <coming-soon v-if="tab === 'book'" /> -->
    </div>
    <integrations-block-modal
      v-if="show_integrations_block_modal"
      @close="show_integrations_block_modal = false"
    />
  </default-layout>
</template>

<script lang="babel">
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import schoolSockets from 'mixins/sockets/schoolSocketEvents';
  import defaultLayout from 'layouts/default/default.vue';
  import adminPortal from 'features/admin/adminPortal/adminPortal.vue';
  import suggestionsTab from 'features/admin/adminPortal/suggestions/suggestionsTab.vue';
  import adminPortalUsers from 'features/admin/adminPortal/adminPortalUsers/adminPortalUsers.vue';
  import adminPortalAddUsers from 'features/admin/adminPortal/adminPortalUsers/addUsers/adminPortalAddUsers.vue';
  import adminPortalCourses from 'features/admin/adminPortal/courses/adminPortalCourses.vue';
  import adminPortalAddCourses from 'features/admin/adminPortal/courses/addCourses/adminPortalAddCourses.vue';
  import adminMemberships from 'features/admin/adminPortal/memberships/adminMemberships.vue';
  import adminPortalIntegrations from 'features/admin/adminPortal/integrations/adminPortalIntegrations.vue';
  import adminPortalIntegrationsRedirectComponent from 'features/admin/adminPortal/integrations/adminPortalIntegrationsRedirectComponent.vue';
  import adminPortalAnalytics from 'features/admin/adminPortal/analytics/adminPortalAnalytics.vue';
  import adminPortalSchoolInfo from 'features/admin/adminPortal/schoolInfo/adminPortalSchoolInfo.vue';
  import comingSoon from 'features/admin/adminPortal/comingSoon.vue';
  import integrationsBlockModal from './integrations/integrationsBlockModal.vue';

  export default {
    data() {
      return {
        tab: 'analytics',
        school_name: '',
        has_new_suggestions:null,
        users_tabs: ['Analytics','Users','Courses','Integrations','Suggestions','Resources','Book PD'],
        show_integrations_block_modal: false,
      };
    },
    components: {
      defaultLayout,
      adminPortal,
      suggestionsTab,
      adminPortalUsers,
      adminPortalAddUsers,
      adminPortalCourses,
      adminPortalAddCourses,
      adminMemberships,
      adminPortalIntegrations,
      adminPortalIntegrationsRedirectComponent,
      adminPortalAnalytics,
      adminPortalSchoolInfo,
      comingSoon,
      integrationsBlockModal
    },
    mixins: [schoolSockets],
    computed: {
      ...mapGetters(['getProfile','getCurrentSchool']),
      displayable_tabs() {
        const tabs = [
          { title:'Analytics', routeName:'admin-analytics', icon:'bar-chart.svg' },
          { title:'Users', routeName: 'admin-users', icon:'group.svg' },
          { title:'Courses', routeName: 'admin-courses',icon:'courses_icon.svg'},
          { title:'Integrations', routeName: 'admin-integrations',icon:'replications_icon.svg'},
          { title:'Suggestions', routeName:'admin-suggestions', icon:'lightbulb.svg' },
          { title:'Resources', routeName:'',  href:'https://drive.google.com/drive/folders/1btY3bRN7Fyt_lbKR5f9SE4mWcCrjZMt_',icon:'folder.svg', externalLink:true },
          { title:'Book PD', routeName:'', href:'https://parlayideas.com/book-pd/', icon:'date.svg', externalLink:true },
          { title:'School Info', routeName:'admin-school-info', icon:'school_info.svg'},
          { title:'Memberships', routeName:'admin-memberships', icon:'license.svg'},
        ];
        if (this.getProfile.role !== 'admin' )
          return tabs.filter(tab => this.users_tabs.includes(tab.title));
        return tabs;
      },
      addUsers(){
        return this.$route.name === 'admin-add-users';
      },
      addCourses(){
        return this.$route.name === 'admin-add-courses';
      },
      hasAdminPermission() {
        if (this.getProfile && this.getProfile.school) {
          return (
            this.getProfile.school.admin_role === 'admin' ||
            this.getProfile.school.admin_role === 'coach'
          );
        } else {
          return false;
        }
      },
    },
    watch: {
      '$route.name'() {
        this.tab= this.$route.name;
      }
    },
    methods: {
      goBack(){
        this.$router.push({name: 'dashboard'});
      },
      goToTab(tab){

        if(tab==='admin-book'){
          const link='https://parlayideas.com/book-pd/';
          window.open(link, '_blank');
        }
       else if(tab==='admin-integrations'){
          if (!this.getCurrentSchool.edlink_integration_is_enabled && this.getProfile.role !== 'admin') {
            this.show_integrations_block_modal = true;
          }else{
            this.tab = tab;
            const routeName =  tab;
            this.$router.push({
              name: routeName,
            });
          }
        }
        else{
          this.tab = tab;
          const routeName = tab;
          this.$router.push({
            name: routeName,
          });
        }
      },
      goToExternalLink(link){
        window.open(link, '_blank');
      },
      is_selected_tab(tabName) {
        return this.$route.name === tabName;
      },
      getSchoolDetails(){
        this.$store.dispatch('getSchoolDetails',this.$route.params.schoolID).then(() => {
          this.has_new_suggestions = this.getCurrentSchool.has_new_suggestions;
        });
      }
    },
    mounted(){
      this.tab= this.$route.name;
      this.getSchoolDetails();

      this.setupSchoolSocket(this.$route.params.schoolID);
      EventBus.$on('has-new-suggestions',() => {
        this.has_new_suggestions = true;
      });
      EventBus.$on('read-new-suggestions',() => {
        this.has_new_suggestions = false;
      });
      //EventBus.$on('reloadAddUsers', () => (this.tab = 'add-users'));
      //EventBus.$on('reloadAddCourses', () => (this.tab = 'add-courses'));
    },
    beforeDestroy() {
      EventBus.$off('read-new-suggestions');
      EventBus.$off('has-new-suggestions');
     // EventBus.$off('reloadAddUsers');
      //EventBus.$off('reloadAddCourses');
      this.leaveSchoolSocket(this.$route.params.schoolID);
    }
  };
</script>



// WEBPACK FOOTER //
// adminPortal.vue?51349f7e